import {
  FileItem,
  IFile,
  IFileUploadResponseDTO,
  InboundDTO,
  Message,
  MessageDTO
} from '@care-portals/api-interfaces';
import { createAction, props } from '@ngrx/store';

export const loadMessages = createAction(
  '[Inbox] Load Messages',
  props<{ filters: any }>()
);

export const loadMessagesSuccess = createAction(
  '[Inbox] Load Messages Success',
  props<{ messages: Message[] }>()
);

export const loadMessagesFailure = createAction(
  '[Inbox] Load Messages Failure',
  props<{ error: any }>()
);

export const getFile = createAction(
  '[Inbox] Get File',
  props<{ fileName: string }>()
);

export const getFileSuccess = createAction(
  '[Inbox] Get File Success',
  props<{ file: IFile }>()
);

export const getFileFailure = createAction(
  '[Inbox] Get File Failure',
  props<{ error: any }>()
);

export const setRawFile = createAction(
  '[Inbox] Set Raw File',
  props<{ resourceId: string, fileItem: IFile }>()
);

export const uploadFiles = createAction(
  '[Inbox] Upload Files',
  props<{ files: IFile[] }>()
);

export const uploadFilesSuccess = createAction(
  '[Inbox] Upload Files Success',
  props<{ files: IFileUploadResponseDTO[] }>()
);

export const uploadFilesFailure = createAction(
  '[Inbox] Upload Files Failure',
  props<{ error: any }>()
);

export const getMessage = createAction(
  '[Inbox] Get Message',
  props<{ id: string }>()
);

export const getMessageSuccess = createAction(
  '[Inbox] Get Message Success',
  props<{ message: Message }>()
);

export const getMessageFailure = createAction(
  '[Inbox] Get Message Failure',
  props<{ error: any }>()
);

export const replyMessage = createAction(
  '[Inbox] Reply Message',
  props<{ inboundDto: InboundDTO; navigate: boolean }>()
);

export const replyMessageSuccess = createAction(
  '[Inbox] Reply Message Success',
  props<{ message: Message }>()
);

export const replyMessageFailure = createAction(
  '[Inbox] Reply Message Failure',
  props<{ error: any }>()
);
